<template>
  <div id="handWrite" class="canvas-box" :style="bgStyle">
    <canvas-part
      ref="childCanvas"
      :dom-wid-hei="domWidHei"
      :canvas-set="canvas_width"
      @switch-eraser="switchEraser"
      :img-src="current_img_url"
    ></canvas-part>
    <div class="template-canvas-tools">
      <div class="tools-box">
        <div class="hide-tools" v-if="tools_type == 4">
          <p @click="choose_background('rgba(255,255,255,0)')">
            <span class="background-lucency-color"></span>
            <span>透明色</span>
          </p>
          <p @click="choose_background('rgba(15, 57, 56,1)')">
            <span class="background-bord-color"></span>
            <span>黑板色</span>
          </p>
          <p @click="choose_background('rgba(255,255,255,1)')">
            <span class="background-white-color"></span>
            <span>白色</span>
          </p>
          <p @click="refresh">
            <!--          <p @click="re_canvas_cancel">-->
            <span class="refresh"></span>
            <span>恢复</span>
          </p>
          <p @click="open_new_bord">
            <span class="tea-new-bord"></span>
            <span>新建</span>
          </p>
          <p @click="openAllhandWrite">
            <span class="tea-open-bord"></span>
            <span>打开</span>
          </p>
          <p @click="saveHandWriteFun">
            <span class="tea-save-bord"></span>
            <span>保存</span>
          </p>
          <p @click="shareHandWrite">
            <span class="tea-share-bord"></span>
            <span>分享</span>
          </p>
        </div>
        <div class="color-tools" v-if="tools_type == 1">
          <p
            v-for="item in color_list"
            :key="item.value"
            @click="choose_color(item, item.value)"
            :class="{ active: canvas_width.line_color == item.value }"
          >
            <span :class="item.type"></span>
            <span>{{ item.text }}</span>
          </p>
        </div>
        <div class="pen-width-tools" v-if="tools_type == 2">
          <p
            v-for="item in line_width_list"
            :key="item.value"
            @click="choose_width(item, item.value)"
            :class="{ active: canvas_width.line_width == item.value }"
          >
            <span :class="item.type"></span>
            <span>{{ item.text }}</span>
          </p>
        </div>
        <div class="graph-tools" v-if="tools_type == 3">
<!--          <div class="grap-tools-box">-->
            <p
                    v-for="item in graph_list"
                    :key="item.type"
                    @click="choose_graph(item.type)"
            >
              <span :class="item.class"></span>
            </p>
<!--          </div>-->
        </div>
        <div class="hand-write-tools">
          <p
            class="pen-color"
            :class="{ active: tools_type == 1 }"
            @click="show_color"
          >
            <span class="black" :class="color_obj.type"></span>
            <span>字色</span>
          </p>
          <p
            class="pen-width"
            :class="{ active: tools_type == 2 }"
            @click="show_line"
          >
            <span class="pen-width-span" :class="line_obj.type"></span>
            <span>线宽</span>
          </p>
          <p @click="eraser_type" class="eraser-type">
            <span class="eraser"></span>
            <span>橡皮</span>
          </p>
          <p @click="clear_canvas">
            <span class="clear"></span>
            <span>清屏</span>
          </p>
          <p @click="show_graph" :class="{ active: tools_type == 3 }">
            <span class="exit-bord"></span>
            <span>图形</span>
          </p>
          <div class="border-item">
            <p @click="recall">
              <span class="recall"></span>
              <span>撤销</span>
            </p>
          </div>

          <div class="border-item">
            <p @click="show_menu" :class="{ active: tools_type == 4 }">
              <span class="hide-menu"></span>
              <span>菜单</span>
            </p>
          </div>
          <div class="border-item">
            <p @click="closeHandWrite">
              <span class="close-bord"></span>
              <span>关闭</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <saveHandWrite
      v-if="show_save_hand_write"
      @selectCourse="selectCourseFun"
      :cur-img-url="canvas_img_url"
      :bgFileId="current_bg_file_id"
      @saveBord="saveBordFun"
      @cloaseSave="cloaseSaveFun"
      :canvasSet="canvas_width"
      :click-new-bord="click_new_bord"
    ></saveHandWrite>
    <shareHandWrite
      v-if="show_share_hand_write"
      :cur-img-url="canvas_img_url"
      :bgFileId="current_bg_file_id"
      @sureShare="sureShareFun"
      :canvasSet="canvas_width"
    ></shareHandWrite>
    <openAllHandWrite
      v-if="show_all_hand_write"
      @selectCourse="selectCourseFun"
      @curImgUrl="curImgUrlFun"
      @close="closeAllHandWriteDialog"
    ></openAllHandWrite>
    <el-dialog
      :visible.sync="dialogVisible"
      class="save-dialog"
      :close-on-click-modal="!dialogVisible"
      :modal-append-to-body="!dialogVisible"
      width="4.1rem"
    >
      <p style="font-size: 0.18rem; line-height: 0.5rem; color: #000">
        <i
          class="el-icon-warning"
          style="
            color: #f7ba2a;
            font-size: 0.26rem;
            vertical-align: middle;
            margin-right: 0.1rem;
          "
        ></i
        ><span style="vertical-align: middle">{{ dialog_title }}</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeHandWriteFun" size="medium">不保存</el-button>
        <el-button type="primary" @click="saveHandWriteFun" size="medium"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./index.scss";
import saveHandWrite from "./part/saveHandWrite";
import shareHandWrite from "./part/shareHandWrite";
import openAllHandWrite from "./part/openAllHandWrite";
import canvasPart from "@/components/canvasPart";

// import html2canvas from "html2canvas";

export default {
  name: "handWrite",
  data: function () {
    return {
      dialogVisible: false,
      close_type: 1,
      click_type: 1,
      dialog_title: "",
      show_share_hand_write: false, //是否显示分享弹窗
      show_save_hand_write: false, //是否显示保存弹窗
      show_all_hand_write: false, //打开全部板书
      pen_type_toggle: false, //橡皮/笔切换
      color_index: 0, //色值index
      line_width_index: 0, //线宽index
      domWidHei: {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      },
      canvasSet: {
        pen_type: "pen",
        line_width: 4, //画笔线宽
        line_color: "#f91505", //画笔颜色，
        back: "raba(255,255,255,0)",
      },
      canvas_backgroud_list: [
        "rgba(255,255,255,0)", //全透明
        "rgba(255,255,255,1)", //纯白
        "rgba(15, 57, 56,1)", //黑板颜色
      ],
      canvas_back_index: 0,
      is_write: false, //是否手写
      canvas_img_url: "",
      canvas_bg_url: '',
      scoll_top: "", //滚动高度
      current_img_url: "",
      current_bg_url: '',
      current_bg_file_id: '',
      click_new_bord: false,
      /********新图形工具*************/
      tools_type: "", //1颜色 2线宽 3图形 4菜单
      canvasCtx: "", //canvas实例化
      graph_list: [
        {
          type: "oval",
          class: "oval-graph",
        },
        {
          type: "line",
          class: "line-graph",
        },
        {
          type: "semicircle",
          class: "semicircle-graph",
        },
        {
          type: "square",
          class: "square-graph",
        },
        {
          type: "rectangle",
          class: "rectangle-graph",
        },
        {
          type: "trapezoid",
          class: "trapezoid-graph",
        },
        {
          type: "triangle",
          class: "triangle-graph",
        },
        {
          type: "polygon",
          class: "polygon-graph",
        },
        {
          type: "cylinder",
          class: "cylinder-graph",
        },
        {
          type: "parallelogram",
          class: "parallelogram-graph",
        },
        {
          type: "right_triangle",
          class: "right_triangle-graph",
        },
        {
          type: "right_trapezoid",
          class: "right_trapezoid-graph",
        },
      ],
      color_list: [
        //笔色
        {
          text: "红色",
          value: "#f41a0a",
          type: "red",
        },
        {
          text: "绿色",
          value: "#43cd40",
          type: "green",
        },
        {
          text: "黑色",
          value: "#000",
          type: "black",
        },
        {
          text: "白色",
          value: "#f5f5f5",
          type: "white",
        },
      ],
      line_width_list: [
        //线宽
        {
          text: "S",
          value: 4,
          type: "s-small",
        },
        { text: "M", value: 6, type: "middle" },
        { text: "L", value: 9, type: "thick" },
      ],
      color_obj: {
        text: "红色",
        value: "#f41a0a",
        type: "red",
      },
      line_obj: {
        text: "S",
        value: 4,
        type: "s-small",
      },
      canvas_width: {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
        back: "rgba(255,255,255,0)",
        pen_type: "pen",
        line_color: "#f41a0a",
        line_width: 4,
      },
      point: {
        //轨迹点
        start_x: "",
        start_y: "",
        end_x: "",
        end_y: "",
      },
    };
  },
  computed: {
    bgStyle() {
      const style = {};

      if (this.current_bg_url) {
        style['background-image'] = `url(${this.current_bg_url})`;
      }

      return style;
    },
  },
  components: {
    saveHandWrite, //保存白板
    shareHandWrite, //分享白板
    openAllHandWrite, //打开板书文件夹
    canvasPart, //canvas组件
  },
  methods: {
    closeHandWriteFun() {
      switch (this.close_type) {
        case 1:
          this.$emit("closeHandWrite", false);
          break;
        case 2:
          this.current_bg_url = '';
          this.click_new_bord = false;
          this.clear_canvas();
          // 新建板书flydata事件
          this.$flydata.flydataTrack(114);
          this.dialogVisible = false;
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    curImgUrlFun(val) {
      this.current_img_url = val.file_cdn_url;
      this.current_bg_url = val.bg_file_cdn_url;
      this.current_bg_file_id = val.bg_file_cdn_id;
      this.canvas_width.back = val.bg_color;
      this.closeAllHandWriteDialog();
    },
    //确认分享
    sureShareFun(val) {
      this.canvas_img_url = "";
      this.show_share_hand_write = false;
      if(!val){//非保存之后的分享
        this.clear_canvas();
      }
    },
    //新建白板
    open_new_bord() {
      if (this.$refs.childCanvas.isDraw) {
        this.click_new_bord = true;
        this.dialog_title = "该页面尚未保存，是否保存板书的修改";
        this.dialogVisible = true;
        this.close_type = 2;
      } else {
        this.current_bg_url = '';
        this.clear_canvas();

        // 新建板书flydata事件
        this.$flydata.flydataTrack(114);
        this.$message({
          message: "当前没有书写板书",
          type: "warning",
        });
      }
    },
    cloaseSaveFun() {
      this.show_save_hand_write = false;
      this.click_new_bord = false;
    },
    //保存之后返回
    saveBordFun(val) {
      this.reset_canvas_set();

      if (this.click_new_bord) {
        this.current_bg_url = '';
      }
      this.cloaseSaveFun();
    },
    //url
    imgUrlFun(val) {
      this.canvas_img_url = val;
      // console.log(this.canvas_img_url,333333333333)
    },
    selectCourseFun(val) {
      console.log(val);
    },
    //获取当前桌面截图
    get_ws_img() {
      let _this = this;
      _this.$ws.onmessage = function (data) {
        _this.test_fun(data.data, _this.canvas_img_url);
      };
    },
    test_fun(backimg, fileimg) {
      var canvas = document.createElement("canvas");
      canvas.width = document.body.clientWidth;
      canvas.height = document.body.clientHeight;
      // var canvas = document.getElementById('myCanvas');
      var context = canvas.getContext("2d");
      var img1 = new Image();
      var img2 = new Image();
      //处理跨域
      img1.crossOrigin = "anonymous";
      img2.crossOrigin = "anonymous";

      img1.src = backimg;
      img2.src = fileimg;
      // console.log(backimg,66666);

      //将两张图片画在一起
      img1.onload = function () {
        context.drawImage(
          img1,
          0,
          0,
          document.body.clientWidth,
          document.body.clientHeight
        );
        context.drawImage(
          img2,
          0,
          0,
          document.body.clientWidth,
          document.body.clientHeight
        );
        // context.drawImage(img1,0,0,500,300);
        // context.drawImage(img2,0,0,500,300);
      };
      setTimeout(() => {
        let final_img = canvas.toDataURL("image/png");
        this.canvas_img_url = final_img;
      }, 500);
      function convertCanvasToImage(canvas) {
        var image = new Image();
        image.src = canvas.toDataURL("image/png");
        return image;
      }
    },
    //点击保存
    saveHandWriteFun() {
      if (this.$refs.childCanvas.isDraw) {
        this.canvas_img_url = this.$refs.childCanvas.getImgUrl();

        this.show_save_hand_write = true;
        this.show_share_hand_write = false;
        this.dialogVisible = false;
        // this.$ws.send(JSON.stringify({
        //     type:"img",
        //     data:null,
        // }));
        // this.get_ws_img();
      } else {
        this.$message({
          message: "当前没有书写板书",
          type: "warning",
        });
      }
    },
    //分享板书
    shareHandWrite() {
      this.click_new_bord = false;
      if (this.$refs.childCanvas.isDraw) {
        this.canvas_img_url = this.$refs.childCanvas.getImgUrl();
        this.click_type = 1;
        this.show_share_hand_write = !this.show_share_hand_write;
        this.show_save_hand_write = false;
      } else {
        this.$message({
          message: "当前没有书写板书",
          type: "warning",
        });
      }
    },
    //点击打开按钮
    openAllhandWrite() {
      this.click_new_bord = false;
      this.show_all_hand_write = true;
      this.show_share_hand_write = false;
      this.show_save_hand_write = false;
      this.click_type = 2;
    },
    closeAllHandWriteDialog() {
      this.show_all_hand_write = false;
    },
    //关闭手写板
    closeHandWrite() {
      this.click_new_bord = false;
      this.$emit("closeHandWrite", false);
      return;
      if (this.$refs.childCanvas.isDraw) {
        this.dialog_title = "该页面尚未保存，是否保存板书";
        this.dialogVisible = true;
        this.close_type = 1;
        return;
        this.$confirm("", "该页面尚未保存，是否保存板书", {
          customClass: "akadm-modal akadm-confirm-box",
          confirmButtonText: "保存",
          cancelButtonText: "不保存",
        })
          .then(() => {
            let _this = this;
            _this.saveHandWriteFun();
          })
          .catch(() => {
            this.$emit("closeHandWrite", false);
          });
      } else {
        this.$emit("closeHandWrite", false);
      }
    },
    //截图
    screenshot(url) {
      return;
      const client_w =
        document.documentElement.clientWidth || document.body.clientWidth;
      const client_h =
        document.documentElement.clientHeight || document.body.clientHeight;
      let ifram_dom = $("#resource-pdf iframe");
      if (ifram_dom) {
        ifram_dom[0].setAttribute("data-html2canvas-ignore", true);
      }
      const _this = this;
      html2canvas(document.body, {
        width: client_w,
        height: client_h,
        x: 0,
        allowTaint: true,
        y: this.scrollTop,
        dpi: window.devicePixelRatio,
      }).then(function (canvas) {
        // return;
        let canvas_cont = canvas.getContext("2d");
        canvas_cont.globalAlpha = 1;
        document.body.appendChild(canvas);
        let init_img_dom = new Image();
        init_img_dom.setAttribute("crossOrigin", "Anonymous");

        //重新截取视频并画在一起
        // let dom = _this.$refs.testCanvas.getContext("2d");
        let vedio = document.getElementsByTagName("video")[0];
        if (vedio) {
          let vedio_width = vedio.clientWidth;
          let vedio_height = vedio.clientHeight;
          let vedio_left = vedio.offsetLeft;
          let vedio_top = vedio.offsetTop;
          // canvas_cont.globalAlpha =0.6;
          canvas_cont.drawImage(
            vedio,
            vedio_left,
            vedio_top,
            vedio_width,
            vedio_height
          );
          init_img_dom.src = url;
          init_img_dom.onload = function () {
            canvas_cont.globalAlpha = 1;
            canvas_cont.drawImage(init_img_dom, 0, 0, client_w, client_h);
          };
          //
        }
        //iframe重画
        if (ifram_dom) {
          // document.getElementsByClassName('')[0]
          // let ifram_dom = $('#resource-pdf iframe');
          let ifram_dom = document.getElementsByClassName("");
          let ifram_content = ifram_dom[0].contentWindow.document.getElementById(
            "outerContainer"
          );
          let ifram_left = ifram_dom[0].offsetLeft;
          let ifram_top = ifram_dom[0].offsetTop;
          let ifram_width = ifram_dom[0].clientWidth;
          let ifram_height = ifram_dom[0].clientHeight;
          let iframe_scr_top =
            document
              .getElementsByTagName("iframe")[0]
              .contentWindow.document.getElementById("viewerContainer")
              .pageYOffset ||
            document
              .getElementsByTagName("iframe")[0]
              .contentWindow.document.getElementById("viewerContainer")
              .scrollTop; //原生兼容

          let iframe_content_height = document
            .getElementsByTagName("iframe")[0]
            .contentWindow.document.getElementById("viewerContainer")
            .getElementsByClassName("page")[0].clientHeight;
          html2canvas(ifram_content, {
            allowTaint: true,
            width: ifram_width,
            height: ifram_height,
            x: 0,
            allowTaint: true,
            y: iframe_scr_top * 1 + iframe_content_height * 1 + 120,
            dpi: window.devicePixelRatio,
          }).then(function (canvases) {
            // canvas_cont.globalAlpha =0.7;
            canvas_cont.drawImage(
              canvases,
              ifram_left,
              ifram_top,
              ifram_width,
              ifram_height
            );
            init_img_dom.src = url;
            init_img_dom.onload = function () {
              canvas_cont.globalAlpha = 1;
              canvas_cont.drawImage(init_img_dom, 0, 0, client_w, client_h);
            };
          });
        }
        _this.canvas_img_url = canvas.toDataURL("image/png");
      });
    },
    /********新图形工具*********/
    //选择背景色
    choose_background(val) {
      this.canvas_width.back = val;
      this.canvasSet.back = this.canvas_backgroud_list[this.canvas_back_index];
    },
    //选择笔色
    choose_color(item, val) {
      this.color_obj = item;
      this.canvas_width.line_color = val;
      this.canvas_width.pen_type = "pen";
      $('.eraser-type').removeClass('active');
    },
    //选择线宽
    choose_width(item, val) {
      this.line_obj = item;
      this.canvas_width.line_width = val;
      this.canvas_width.pen_type = "pen";
      $('.eraser-type').removeClass('active');
    },
    //选择图形
    choose_graph(val) {
      this.canvas_width.pen_type = "pen";
      this.draw_svg_img(val);
    },
    draw_svg_img(val) {
      this.$refs.childCanvas.addShape(`shape_${val}_l.svg`);
    },
    //清屏
    clear_canvas() {
      this.canvas_width.pen_type = "pen";
      this.$refs.childCanvas.clear_canvas();
    },
    //选择线宽
    show_line() {
      this.canvas_width.pen_type = "pen";
      this.toggle_bar_item(2);
    },
    //选择笔色
    show_color() {
      this.canvas_width.pen_type = "pen";
      this.toggle_bar_item(1);
    },
    //图形
    show_graph() {
      this.$flydata.flydataTrack(287);
      this.canvas_width.pen_type = "pen";
      this.toggle_bar_item(3);
    },
    //菜单
    show_menu() {
      this.canvas_width.pen_type = "pen";
      this.toggle_bar_item(4);
    },
    //撤销
    recall() {
      this.$refs.childCanvas.canvas_cancel();
    },
    //恢复
    refresh() {
      this.$refs.childCanvas.re_canvas_cancel();
    },
    toggle_bar_item(type) {
      if (this.tools_type == type) {
        this.tools_type = "";
      } else {
        this.tools_type = type;
      }
      $('.eraser-type').removeClass('active');
    },
    //橡皮擦
    eraser_type() {
      this.canvas_width.pen_type = this.canvas_width.pen_type === "eraser" ? "pen" : "eraser";
      // $('.eraser-type span:nth-of-type(2)').toggleClass('active');
      $('.eraser-type').toggleClass('active');
    },
    drawing() {
      if (this.drawingObject) {
        this.canvasCtx.remove(this.drawingObject);
      }

      switch (this.currentTool) {
        case "pencil":
          this.canvasCtx.isDrawingMode = true;
          break;
        case "remove":
          break;
        default:
          // statements_def'
          break;
      }
    },
    //  重置设置
    reset_canvas_set() {
      this.clear_canvas();
    },
    switchEraser() {
      this.canvas_width.pen_type = "eraser";
    },
  },
};
</script>

<style scoped lang="scss" src="./index.scss"></style>
